export const TOGGLE_DRAWER = 'HOME/TOGGLE_DRAWER'
export const CLOSE_DRAWER = 'HOME/CLOSE_DRAWER'
export const SET_NAV_BACK = 'HOME/SET_NAV_BACK'
export const SET_NAV_BAR_LOADING = 'HOME/SET_NAV_BAR_LOADING'
export const TOGGLE_NAV_BAR_SEARCH = 'HOME/TOGGLE_NAV_BAR_SEARCH'
export const SET_OVERLAY_LOADING = 'HOME/SET_OVERLAY_LOADING'
